import React from 'react';
import about from '../images/about_org.jpg';
import digital from '../images/digital-marketing.jpg';
import { useDocTitle } from '../components/CustomHook';
import CommonContainer from "../components/CommonContainer";
import { commonStyles } from "../pages/commonStyles";
function Digitalmarketing() {
  useDocTitle("Digital Marketing");

  return (
    <div>
      {/* Hero Section */}
    <div className="relative overflow-hidden mt-4 lg:mt-0 h-[320px] md:h-[380px] lg:h-[450px]">
        <div className="absolute inset-0 z-0">
          <img
            src={about}
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>

       <div className="relative z-20 h-full flex items-center justify-center text-center text-white">
  <h2 className={`${commonStyles.pageTitle} text-white`}>
    Digital Marketing
  </h2>
</div>
      </div>
<CommonContainer>
      {/* Section Title */}
      {/* <div className="mt-16">
        <p className="font-bold text-blue-500 mb-6 text-center
                      text-lg md:text-xl lg:text-2xl">
          Digital Marketing
        </p>
      </div> */}

      {/* Intro Section */}
     <div className="flex flex-col lg:flex-row items-center
                my-8 gap-8">

        {/* Text */}
        <div className="w-full lg:w-1/2">

  <h1 className={`${commonStyles.heading} mb-6`}>
    Digital Marketing
  </h1>
          <p className={`${commonStyles.paragraph} mb-4`}>
            Digital Marketing is inseparable in the recent past and has become
            an important component of marketing of any brand that utilizes
            internet and online based digital technologies. No one can deny
            their presence on digital media which brings in a majority of
            customer base and sales from the internet today.
          </p>

          <p className={`${commonStyles.paragraph} mb-4`}>
            Quadprosoft technologies, with their expertise and experience in
            digital marketing, offer clients a wide range of services, benefits,
            and brand recognition by attracting potential customers from the
            internet. Our services include the following.
          </p>
        </div>

        {/* Image */}
        <div className="w-full lg:w-1/2">
          <img
            src={digital}
            alt="Digital Marketing"
            className="w-full h-auto object-cover rounded-lg shadow-lg"
          />
        </div>
      </div>

      {/* Services List */}
      <div>
        <ul className="space-y-8 md:space-y-10 ml-0 md:ml-6 lg:ml-28">
          {[
            {
              title: "Email Marketing",
              desc:
                "Email marketing involves sending commercial messages to a group of people using email to advertise products, request business, or build customer relationships."
            },
            {
              title: "Search Engine Optimization (SEO)",
              desc:
                "SEO improves the quality and quantity of website traffic from search engines by targeting unpaid and organic search results."
            },
            {
              title: "YouTube Marketing",
              desc:
                "YouTube helps businesses promote products, build brand identity, provide customer support, and reach a global audience through video."
            },
            {
              title: "Facebook Marketing",
              desc:
                "Facebook marketing allows brands to reach a massive audience through paid advertisements and organic posts."
            },
            {
              title: "Twitter Marketing",
              desc:
                "Twitter marketing focuses on creating and distributing content to engage audiences and increase brand visibility."
            },
            {
              title: "Quora Marketing",
              desc:
                "Quora marketing builds brand authority by answering relevant questions using meaningful insights, stats, and case studies."
            },
            {
              title: "Google Ads",
              desc:
                "Google Ads allows advertisers to display ads across search engines, websites, apps, and videos through paid bidding."
            },
            {
              title: "Google Analytics",
              desc:
                "Google Analytics tracks and reports website traffic to help businesses understand user behavior."
            },
            {
              title: "Instagram Marketing",
              desc:
                "Instagram marketing helps brands reach over a billion users and build engagement through visual content."
            },
            {
              title: "LinkedIn Marketing",
              desc:
                "LinkedIn marketing helps businesses network with potential clients and generate indirect sales opportunities."
            },
            {
              title: "Facebook Ads",
              desc:
                "Facebook Ads enable highly targeted advertising to specific audiences using advanced targeting tools."
            }
          ].map((item) => (
            <li key={item.title}>
             <div className="flex items-start text-[23px] font-bold text-blue-900">
               <span className="text-green-500 text-[30] mr-3 mt-1">✔</span>
                {item.title}
              </div>
             <p className="mt-2 text-[18px] leading-8 text-gray-600 text-left">
                {item.desc}
              </p>
            </li>
          ))}
        </ul>

        {/* Contact */}
        <div className="my-10">
         <p className={`${commonStyles.paragraph} mb-4`}>
            To find out more about our consulting capabilities, please{' '}
            <a href="/contact" className="text-blue-500 hover:underline">
              contact us
            </a>.
          </p>
        </div>
      </div>
      </CommonContainer>
    </div>
  );
}

export default Digitalmarketing;
